<app-header> Loading...</app-header>
<div class="container-fluid flex-grow-1 flex-shrink-0">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
